export const getMatchTeams = (teams) => {
  const userTeam = localStorage.getItem('teams');
  if (!teams) return [];
  if (!userTeam) return teams;
  const filteredTeams = teams.filter((item) => {
    return item.equipes.some((team) => userTeam?.includes(team));
  });
  return filteredTeams;
};
